import { render, staticRenderFns } from "./courseSectionDescription.html?vue&type=template&id=222cc03e&scoped=true&"
import script from "./courseSectionDescription.js?vue&type=script&lang=js&"
export * from "./courseSectionDescription.js?vue&type=script&lang=js&"
import style0 from "./courseSectionDescription.css?vue&type=style&index=0&id=222cc03e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222cc03e",
  null
  
)

export default component.exports